import { Sparkles, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import { NearbyArena } from 'modules/jogador/player-home/content';
import { Card } from 'shared/components/ui/Card';
import { Avatar } from 'shared/components/ui/Avatar';
import { ROUTES } from 'shared/constants/routes';
import { cn } from 'shared/utils/cn';
import { useToast } from 'shared/components/ui/Toast';

interface ArenaListProps {
  arenas: NearbyArena[];
}

export function ArenaList({ arenas }: ArenaListProps) {
  const toast = useToast();

  return (
    <div>
      <div className="flex items-center justify-between">
        <h2 className="font-heading text-lg font-semibold text-ink">Arenas perto de você</h2>
        <button type="button" className="text-sm font-medium text-primary hover:underline"
          onClick={() =>
            toast({
              tone: 'info',
              title: 'Mapa das arenas',
              description: 'Em breve: arenas próximas de você no mapa de Fortaleza.',
            })
          }>
          Ver mapa
        </button>
      </div>

      <div className="mt-4 flex flex-col gap-3">
        {arenas.map((arena) => (
          <Link key={arena.id} to={ROUTES.BOOKING}>
            <Card
              className={cn(
                'flex items-center gap-4 p-4 transition-shadow hover:shadow-none',
                arena.isNew && 'border-primary/50 ring-2 ring-primary/15'
              )}
            >
              <Avatar name={arena.name} />
              <div className="flex-1">
                <p className="flex flex-wrap items-center gap-2 font-medium text-ink">
                  {arena.name}
                  {arena.isNew && (
                    <span className="inline-flex items-center gap-1 rounded-full bg-accent-soft px-2 py-0.5 text-xs font-semibold text-primary-dark">
                      <Sparkles className="h-3 w-3" aria-hidden="true" />
                      Nova na plataforma
                    </span>
                  )}
                </p>
                <p className="text-sm text-ink-secondary">
                  {arena.distanceKm} km · {arena.courts} quadras · {arena.surface}
                  {!arena.isNew && (
                    <>
                      {' · '}
                      <Star className="inline h-3.5 w-3.5 -translate-y-px fill-warning text-warning" aria-hidden="true" />{' '}
                      {arena.rating}
                    </>
                  )}
                </p>
                <p className="text-sm text-ink-secondary">
                  a partir de{' '}
                  <span className="font-medium text-primary">R$ {arena.priceFrom}/h</span>
                </p>
              </div>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
